var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map((p=>{return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	50911: () => (loadStrictVersion("default", "@emotion/react", false, [1,11,13,3], () => (Promise.all([__webpack_require__.e(917), __webpack_require__.e(348)]).then(() => (() => (__webpack_require__(58967))))))),
	36114: () => (loadStrictVersion("default", "@emotion/styled", false, [1,11,13,0], () => (__webpack_require__.e(860).then(() => (() => (__webpack_require__(71479))))))),
	57586: () => (loadStrictVersion("default", "date-fns", false, [1,4,1,0], () => (Promise.all([__webpack_require__.e(220), __webpack_require__.e(980)]).then(() => (() => (__webpack_require__(9980))))))),
	60736: () => (loadStrictVersion("default", "@tanstack/react-query", false, [1,5,62,7], () => (__webpack_require__.e(946).then(() => (() => (__webpack_require__(85946))))))),
	3673: () => (loadStrictVersion("default", "sanitize-html", false, [1,2,15,0], () => (Promise.all([__webpack_require__.e(728), __webpack_require__.e(172)]).then(() => (() => (__webpack_require__(74728))))))),
	3701: () => (loadSingletonVersion("default", "react-router-dom", true, [1,6,21,1], () => (() => (__webpack_require__(92648))))),
	6883: () => (loadSingletonVersion("default", "date-fns-tz", false, [1,3,2,0], () => (Promise.all([__webpack_require__.e(220), __webpack_require__.e(797)]).then(() => (() => (__webpack_require__(13797))))))),
	10039: () => (loadStrictVersion("default", "@mui/x-data-grid", false, [1,7,18,0], () => (Promise.all([__webpack_require__.e(420), __webpack_require__.e(527), __webpack_require__.e(935)]).then(() => (() => (__webpack_require__(27935))))))),
	30431: () => (loadStrictVersion("default", "dayjs", false, [1,1,11,13], () => (__webpack_require__.e(353).then(() => (() => (__webpack_require__(74353))))))),
	31100: () => (loadStrictVersion("default", "react-use-measure", false, [1,2,1,1], () => (__webpack_require__.e(154).then(() => (() => (__webpack_require__(59154))))))),
	35824: () => (loadSingletonVersion("default", "zone.js", true, [2,0,14,3], () => (() => (__webpack_require__(38216))))),
	37137: () => (loadStrictVersion("default", "react-idle-timer", false, [1,5,7,2], () => (__webpack_require__.e(87).then(() => (() => (__webpack_require__(7087))))))),
	46788: () => (loadStrictVersion("default", "@casetext/prometheus", false, [1,2,1,21], () => (__webpack_require__.e(919).then(() => (() => (__webpack_require__(53919))))))),
	48173: () => (loadStrictVersion("default", "classnames", false, [1,2,5,1], () => (__webpack_require__.e(485).then(() => (() => (__webpack_require__(32485))))))),
	53481: () => (loadSingletonVersion("default", "react-redux", true, [1,9,0,4], () => (() => (__webpack_require__(45135))))),
	53638: () => (loadSingletonVersion("default", "zustand", true, [1,4,5,2], () => (() => (__webpack_require__(34085))))),
	53989: () => (loadStrictVersion("default", "powerbi-client-react", false, [1,1,4,0], () => (__webpack_require__.e(164).then(() => (() => (__webpack_require__(93164))))))),
	59518: () => (loadStrictVersion("default", "@reduxjs/toolkit", false, [1,2,0,1], () => (Promise.all([__webpack_require__.e(527), __webpack_require__.e(558)]).then(() => (() => (__webpack_require__(55558))))))),
	62483: () => (loadStrictVersion("default", "@casetext/basenji", false, [2,0,8,0], () => (__webpack_require__.e(243).then(() => (() => (__webpack_require__(80243))))))),
	63345: () => (loadStrictVersion("default", "react-helmet-async", false, [1,2,0,5], () => (Promise.all([__webpack_require__.e(902), __webpack_require__.e(824)]).then(() => (() => (__webpack_require__(85902))))))),
	66866: () => (loadStrictVersion("default", "@datadog/browser-rum", false, [1,5,28,0], () => (__webpack_require__.e(178).then(() => (() => (__webpack_require__(27178))))))),
	66893: () => (loadStrictVersion("default", "@mui/material", false, [1,6,1,3], () => (Promise.all([__webpack_require__.e(420), __webpack_require__.e(917), __webpack_require__.e(821)]).then(() => (() => (__webpack_require__(28821))))))),
	67868: () => (loadStrictVersion("default", "usehooks-ts", false, [1,3,1,0], () => (__webpack_require__.e(103).then(() => (() => (__webpack_require__(65103))))))),
	77171: () => (loadStrictVersion("default", "@mui/icons-material", false, [1,6,1,3], () => (__webpack_require__.e(123).then(() => (() => (__webpack_require__(73123))))))),
	91539: () => (loadStrictVersion("default", "axios", false, [1,1,9,0], () => (__webpack_require__.e(914).then(() => (() => (__webpack_require__(31914))))))),
	92067: () => (loadSingletonVersion("default", "@openfeature/react-sdk", true, [2,0,4,2], () => (() => (__webpack_require__(89663))))),
	13824: () => (loadStrictVersion("default", "react-fast-compare", false, [1,3,2,2], () => (__webpack_require__.e(115).then(() => (() => (__webpack_require__(30115))))))),
	37172: () => (loadStrictVersion("default", "postcss", false, [1,8,2,1], () => (Promise.all([__webpack_require__.e(418), __webpack_require__.e(445)]).then(() => (() => (__webpack_require__(2418))))))),
	52262: () => (loadSingletonVersion("default", "@grapecity/wijmo", true, [1,5,20241,9], () => (() => (__webpack_require__(86901))))),
	47888: () => (loadSingletonVersion("default", "@grapecity/wijmo.odata", true, [1,5,20241,9], () => (() => (__webpack_require__(74966))))),
	92769: () => (loadSingletonVersion("default", "react", true, [1,18,2,0], () => (() => (__webpack_require__(96540))))),
	59783: () => (loadSingletonVersion("default", "react-dom", true, [1,18,2,0], () => (() => (__webpack_require__(40961)))))
};
var initialConsumes = [52262,47888,92769,59783];
initialConsumes.forEach((id) => {
	__webpack_require__.m[id] = (module) => {
		// Handle case when module is used sync
		installedModules[id] = 0;
		delete __webpack_require__.c[id];
		var factory = moduleToHandlerMapping[id]();
		if(typeof factory !== "function") throw new Error("Shared module is not available for eager consumption: " + id);
		module.exports = factory();
	}
});
var chunkMapping = {
	"114": [
		36114
	],
	"172": [
		37172
	],
	"287": [
		3673,
		3701,
		6883,
		10039,
		30431,
		31100,
		35824,
		37137,
		46788,
		48173,
		53481,
		53638,
		53989,
		59518,
		62483,
		63345,
		66866,
		66893,
		67868,
		77171,
		91539,
		92067
	],
	"586": [
		57586
	],
	"736": [
		60736
	],
	"824": [
		13824
	],
	"911": [
		50911
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}